import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import { defaultFormatPaywallCurrency } from "../constants";
import type { PriceScenariosProps } from "../types";
import { Title } from "./Title";

const getIntroFee = ({
  price,
  paywall,
  couponApplication,
}: PriceScenariosProps) => {
  if (!price.upfront_payment_amount) {
    return null;
  }

  const totalPrice = price.upfront_payment_amount;
  const priceDiscounted =
    totalPrice - (couponApplication?.discount_amount || 0);

  let title;
  let oldTitle;

  if (couponApplication) {
    title = formatPaywallCurrencyAmount(
      paywall.currency,
      priceDiscounted,
      defaultFormatPaywallCurrency,
    );
    oldTitle = formatPaywallCurrencyAmount(
      paywall.currency,
      totalPrice,
      defaultFormatPaywallCurrency,
    );
  } else {
    title = formatPaywallCurrencyAmount(
      paywall.currency,
      totalPrice,
      defaultFormatPaywallCurrency,
    );
    oldTitle = undefined;
  }

  return {
    oldTitle,
    title,
    suffix: t("intro_fee").toLowerCase(),
  };
};

export const IntroFee = (props: PriceScenariosProps) => {
  const titleProps = getIntroFee(props);

  if (!titleProps) {
    return null;
  }

  return <Title {...titleProps} />;
};
